module.exports = __webpack_public_path__ + "img/03.a859c062.png";